import { useEffect, useRef, useState, type ReactNode } from "react";

/** Largeur à laquelle la fiche est dessinée (celle d'un écran large) : elle est ensuite réduite pour tenir dans le cadre. */
const DESIGN_WIDTH = 900;

/**
 * Aperçu de la fiche à sa mise en page « grand écran » (3 colonnes, comme à l'impression), réduit pour tenir dans la
 * largeur disponible. Sans cela, la fiche serait écrasée ou déborderait sur les écrans moyens.
 */
export function FitPreview({ children }: { children: ReactNode }) {
  const frame = useRef<HTMLDivElement>(null);
  const content = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);
  const [height, setHeight] = useState<number | undefined>();

  useEffect(() => {
    const frameEl = frame.current;
    const contentEl = content.current;
    if (!frameEl || !contentEl) return;
    const measure = () => {
      const next = Math.min(1, frameEl.clientWidth / DESIGN_WIDTH);
      setScale(next);
      setHeight(contentEl.offsetHeight * next);
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(frameEl);
    observer.observe(contentEl);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={frame} className="w-full overflow-hidden" style={{ height }}>
      <div
        ref={content}
        style={{
          width: DESIGN_WIDTH,
          transform: `scale(${scale})`,
          transformOrigin: "top left",
        }}
      >
        {children}
      </div>
    </div>
  );
}
